import ExcelJS from 'exceljs';
import { showErrorSnackbar } from '../snackBar/snakbar';
import { textWrap } from '@syncfusion/ej2-react-charts';

export const createWorkbook = (module) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(module);
    const hiddenSheet = workbook.addWorksheet("LookupTable");
    hiddenSheet.state = "hidden";
    return { workbook, worksheet, hiddenSheet};
};

export const addTable = (worksheet, fields) => {
    worksheet.addTable({
        name: "head",
        ref: "A1",
        headerRow: true,
        totalsRow: false,
        style: {
            theme: null,
            showFirstColumn: false,
            showLastColumn: true,
            showRowStripes: true,
        },
        columns: fields.map((header) => ({ name: header.label })),
        rows: [],
    });
};

export const applyStyling = (worksheet, fields) => {
    fields.forEach((header, index) => {
        worksheet.getColumn(index + 1).width =  36;
    });

    const headerRow = worksheet.getRow(1);
    headerRow.height = 22;
    headerRow.eachCell((cell) => {
        cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "e1f4f5" },
            bgColor: { argb: "e1f4f5" },
        };
        cell.font = {
            bold: true,
            color: { argb: "070808" },
        };
        cell.alignment = {
            vertical: "middle",
            horizontal: "center",
        };
    });

   for (let i = 2; i <= 10; i++) {
    const row = worksheet.getRow(i);
    // row.height = 22
    row.alignment = { wrapText: true };
}

worksheet.columns.forEach((column) => {
    let maxLength = 0;
    column.eachCell({ includeEmpty: true }, (cell) => {
        const cellValue = cell.value ? cell.value.toString() : "";
        maxLength = Math.max(maxLength, cellValue.length);
    });
    column.width = 36; 
});

};

export const downloadWorkbook = async (workbook, module, format) => {
    try {
        const buffer = await workbook.xlsx.writeBuffer();
        // let fileExtension = "xlsx";
        let fileExtension = format;
        let blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        const currentDate = new Date().toISOString().slice(0, 10);
        const randomNumber = Math.floor(Math.random() * 9000) + 1000;
        link.setAttribute(
            "download",
            `ledgerX_import_data_${module}${randomNumber}_${currentDate}.${fileExtension}`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } catch (error) {
        console.error(error);
        showErrorSnackbar("Something went wrong. Please try again later");
    }
};

export const generateTemplate = async (fields, module, format) => {
    try {
        const { workbook, worksheet } = createWorkbook(module);
        addTable(worksheet, fields);
        applyStyling(worksheet, fields);
        await downloadWorkbook(workbook, module, format);
    } catch (error) {
        console.error(error);
        showErrorSnackbar("Something went wrong. Please try again later");
    }
};

export const addDropdowns = async (col, options, sheet,hiddenSheet, i) => {

    if (options.length > 10 || i) {

        options.forEach((option, index) => {
            hiddenSheet.getCell(`${i}${index + 1}`).value = option;
        });
        sheet.dataValidations.add(col, {
            type: "list",
            allowBlank: false,
            formulae: [`LookupTable!${i}$1:${i}${options.length}`],
        });
     
    } else {
        sheet.dataValidations.add(`${col}`, {
            type: "list",
            allowBlank: false,
            formulae: [`"${options.join(",")}"`],
        });
    }
};
